/*
loading: false,
        responseBody: (action.type) ? action : action.payload.error,
        error: action.payload.message,
        errorObject:action.payload
        */
import Responses from './responses';
import User from './user';
import Forms from './forms';
import SearchconsoleModel from './dataModels/searchconsole';
import GoogleAnalyticsModel from './dataModels/googleanalytics';
import AdwordsModel from './dataModels/adwords';
import moment from 'moment';
import Connection from "./models2/Connection";
import Adaccount from "./models2/Adaccount";
import Company from './models2/Company';
import Location from './models2/Location';
import Dashboard from "./models2/Dashboard";
import Webid from "./models2/Webid";
import Metric from './models2/Metric';
import Ubereatz from './models2/Ubereatz';
import Facebook from "./models2/Facebook";
import Callrail from './models2/Callrail';
import Campaign from "./models2/Campaign";
import Element from "./models2/Element";
import Google from "./models2/Google";
import Assignment from './models2/Assignment';
import Users from "./models2/Users";
import Adwords from "./models2/Adwords";
import Calltrackingmetrics from './models2/Calltrackingmetrics';
import Calllocation from './models2/Calllocation';
import Media from "./models2/Media";
import Marketing from "./models2/Marketing";
import Network from "./models2/Network";
import Simpliad from "./models2/Simpliad";

class Session extends Responses{
            constructor(params){
                super(params);
                    this.apiModels = {
                        Searchconsole:SearchconsoleModel,
                        Adwords:AdwordsModel
                    }
                    this.session = {};
                    this.accounts = {};
                    this.session.permissionsTable = (params.data && params.data.accounts && params.data.accounts.permissionsTable) ? params.data.accounts.permissionsTable : [];
                    this.session.remoteKey = false;
                    this.session.userRoles = false;
                    this.session.key = false;
                    this.session.expired = (params.codeIndex && params.codeIndex == '10-100-02') ? true : false;
                    this.session.expires = false;
                    this.analytics = {};
                    this.session.email = false;
                    this.siteSettings = false;
                    this.session.cookie = false;
                    this.session.perms=["analytics","analytics-super-admin","analytics-owner"]
                    this.ui = {contentModal:{url:""}};
                    this.user = false;
                    this.reportName;
                    this.hasError = false;
                    this.hasResponse = false;
                    this.uniqueString = Math.random().toString(36).substring(2,7);
                    this.models = {
                        Networks:Network,
                        Adwords:Adwords,
                        Webid:Webid,
                        Connection:Connection,
                        Companies:Company,
                        Locations:Location,
                        Campaign:Campaign,
                        Calltrackingmetrics:Calltrackingmetrics,
                        Ubereatz:Ubereatz,
                        Marketing:Marketing,
                        Callrail:Callrail,
                        Facebook:Facebook,
                        Calllocation:Calllocation,
                        Medias:Media,
                        Metrics:Metric,
                        Assignments:Assignment,
                        User:Users,
                        Google:Google,
                        Elements:Element,
                        Adaccount:Adaccount,
                        Dashboards:Dashboard,
                        Simpliads:Simpliad
                    }
                    this.setSessionParameters(params);
                    this.forms = new Forms(this);
                    
        }
    
          
            setSessionParameters(params){
              for (var prop in params){
                  if (params.hasOwnProperty(prop)){
                      var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                      if (this[method]){
                        
                          this[method](params[prop]);
                      }
                      
                  }
              }
              if (this.response && this.sdk){
                if (this.response[this.sdk] && this.response[this.sdk][this.pageVariable]){
                        this.formatPageVariable(); 
                }
              }
            }
            setPayload(obj){
                this.setSessionParameters(obj);
            }

          
        
    

            setCompare(obj){
                if (this.response.payload.api && this.response.payload.api.sdk){
                    this.analytics[this.response.payload.api.sdk] = (this.analytics[this.response.payload.api.sdk]) ? this.analytics[this.response.payload.api.sdk] : {};
                    if (this.reportName){
                        this.analytics[this.response.payload.api.sdk][this.reportName] = (this.analytics[this.response.payload.api.sdk][this.reportName]) ? this.analytics[this.response.payload.api.sdk][this.reportName] : [];
                        this.analytics[this.response.payload.api.sdk][this.reportName].compareData = obj;
                    }else{
                    this.analytics[this.response.payload.api.sdk].compareData = obj;
                    }
                }
            }

     
            setSiteSettings(obj){
                this.siteSettings = obj;
            }
           
          

                setAccounts(z){
                    var accs = {access:{custom:true,default:true}};
                    var arr = (z.accounts) ? z.accounts : z;
                    this.accounts["access"] = [];
                    this.accounts["Element"] = [];
                    this.accounts["Dashboard"] = [];
                    this.accounts.Metric = [];
                    var items;
                    for (var a of arr){
                        var idx = a.account.charAt(0).toUpperCase() + a.account.slice(1);
                           // account = (a.account == "connection") ? a.connection.account : a.account;
                            a.account = (a.account == "dashboards") ? "dashboard" : a.account;
                            a.account = (a.account == "medias") ? "media" : a.account;
                            if (a.account == 'elements'){
                                console.log("element");
                            }
                        
                        var label;
                        items = [];
                        if (a.account == "media"){items = a.MediaFiles;}else{
                        items = (Array.isArray(a[a.account])) ? a[a.account] : a.account ? [a[a.account]] : [];
                        }
                        var t = {};
                        var str = a.account+"Id";
                        
                        var objects =  items.map((itm) => {
                           if (itm && a.account != 'assignments'){
                            itm[str] = itm ? itm.documentId ? itm.documentId : itm.id ? itm.id : false : false;
                                if (a.account == "assignments"){
                                    a.element = itm.element ? itm.element : a.element ? a.element : [];
                                    a.updateTree = (obj) => {
                                            if (obj.parent){
                                                if (t[obj.parent]){
                                                    t[obj.parent].addAssignment(obj);
                                                }else{
                                                    t[obj.elementId] = obj;
                                                }
                                            }else{
                                                var placed = false;
                                                if (Object.keys(t).length){
                                                Object.keys(t).map((_t) => {
                                                if (obj.elementId == t[_t].parent){
                                                    obj.addAssignment(t[_t]);
                                                    placed = true;
                                                    delete t[_t];
                                                    t[obj.elementId] = t[obj.elementId] ? t[obj.elementId].addAssignment(obj) : obj;
                                                }
                                                })
                                            }
                                            if (!placed){
                                                t[obj.elementId] = obj;
                                            }
                                            }
                                            }
                                }
                                var o = new this.models[idx]({...a,...itm});
                                label = o.accountLabel;
                                this.accounts["access"] = this.accounts["access"].concat(o.access);
                                return o;
                            }else{
                                var o = new this.models[idx]({...a});
                                label = o.accountLabel;
                                this.accounts["access"] = this.accounts["access"].concat(o.access);
                                return o;
                            }
                            }).filter(a=>a);
                        this.accounts[label] = this.accounts[label] ? this.accounts[label] : [];
                            this.accounts[label] = (t && Object.keys(t).length) ? Object.keys(t).map((_t)=>{return t[_t];}) : this.accounts[label].concat(objects)
                            
                            if (this.accounts.Location){
                                    var uc = {};
                                    this.accounts.Location.map((l) => {
                                        if (l.company && l.company.domain){
                                            uc[l.company.domain] = (uc[l.company.domain]) ? uc[l.company.domain] : new Company(l.company);
                                            uc[l.company.domain].locations.push(l);
                                        }
                                    })
                                    this.accounts.Company = [];
                                    Object.keys(uc).map((uuc) => {
                                            this.accounts.Company.push(uc[uuc]);
                                    })
                            }
                        }
                    if (this.accounts.Dashboard){
                        this.accounts.Dashboard.map((d) => {
                            if (d.network){
                            var hasNet = false;
                            if (this.accounts.Network){
                                this.accounts.Network.map((n) => {
                                        if (d.network && d.network.documentId == n.documentId){
                                            hasNet = true;
                                        }
                                })
                            }
                            if (!hasNet){
                                this.accounts.Network = this.accounts.Network ? this.accounts.Network : [];
                                this.accounts.Network.push(new this.models["Networks"](d.network));
                            }
                        }
                        })
                    }
                    this.accounts.Simpliad = this.accounts.Simpliad ? {...this.accounts.Simpliad[0].user_email,...this.accounts.Simpliad.pop()} : false;
                }


            setSwitches(z){
                    var accs = {access:{custom:true,default:true}};
                    var arr = z;
                    this.switches = [];
                    
                    arr.map((a) => {
                        var idx = a.account.charAt(0).toUpperCase() + a.account.slice(1);
                           // account = (a.account == "connection") ? a.connection.account : a.account;
                            a.account = (a.account == "networks") ? "network" : a.account;
                            a.account = (a.account == "dashboards") ? "dashboard" : a.account;
                            a.account = (a.account == "elements") ? "element" : a.account;
                            a.account = (a.account == "assignments") ? "assignment" : a.account;
                        
                        
                        
                        var o = new this.models[idx]({...a});
                            this.switches.push(o);
                      
                            
                            
                    });
                    this.data = this.switches;
                }
            setSettings(obj){
                obj.dashboardSettings = (obj.dashboardSettings) ? JSON.parse(obj.dashboardSettings) : {};
                var f = (obj.fullName) ? obj.fullName.split(" ").shift() : "";
                var l = (obj.fullName) ? obj.fullName.replace(f+" ","") : "";
                obj.firstName = f;
                obj.lastName = l;
                this.configuration = obj.simpliads ? obj.simpliads.pop() : obj;
                this.session.userRoles = this.session.permissionsTable.map((pt) => {
                    return (pt.accountId == "Useraccount" && pt.pivotAccountId == "Analytics") ? pt.roleIds : false;
                }).filter(a=>a).pop();
                this.session.userRoles = [7];
                this.configuration.permissionsTable = this.session.permissionsTable;
            }
         
            setBody(obj){
                this.setSessionParameters(obj);
            }

            setAccount(obj){
                this.session.account = obj;
            }
            setAccountType(str){
                this.session.accountType = str;
            }

            setKey(str){
                this.session.remoteKey = str;
                this.session.expired = false;
            }
            setPassport(str){
                this.user = str.user;
            }

            setMedia(arr){
                this.media = arr;
            }

            setExpires(dateTime){
                this.session.expires = dateTime;
            }

            setData(obj){
                this.setSessionParameters(obj);
            }
        

    setReports = async (obj) => {
                var api = (obj.api) ? obj.api : "unknown";
                delete obj.api;
                this.analytics[api] = this.analytics[api] ? this.analytics[api] : obj;
               
                
            }


            setUi(obj){
                this.setSessionParameters(obj);
            }



            setApiCategories(arr){
                arr.map((c) => {
                    this.ui.apiCategories = (this.ui.apiCategories) ? this.ui.apiCategories : [];
                    this.ui.apiCategories.push(c);
                })
            }

        
        }
export default Session;
          

